import React from 'react'
import "./ShopHeader.css"
import primaryImage from "../../assets/img/shop-primary-header.jpg";
import Heading from '../Heading/Heading';




const ShopHeader = ({type}) => {
   
    return (
      <React.Fragment>
        <div className="shop-header">
          <img src={primaryImage} alt="" />
          <div className="shop-header-text">
            <Heading
              style={{
                letterSpacing: "3px",
                fontFamily: "var(--font-raleway)",
                textTransform:"uppercase"
              }}
              fontWeight="400"
              fontSize="30"
            >
              SHOP {type !== "all"?type:""}
            </Heading>
          </div>
        </div>
   
      </React.Fragment>
    );
}

export default ShopHeader
